import { Component, OnInit } from '@angular/core';

import { Modal } from 'angular2-modal/plugins/bootstrap';


export class NotificationBarTypeClientSpeedupActivationComponent {
	constructor(
		public modal: Modal,
	) {}
static ctorParameters() { return [ { type: Modal } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/notification/bar/type/client-speedup-activation/client-speedup-activation.component.ts